<template>
  <div class="user-cabinet__inner">
    <div class="user-cabinet__area w-95">

      <div class="search-container">
        <div class="search__grid">
          <div>
            <div class="search__title">Search Groups</div>
            <div class="search__text">These are networks on specific strategy topics. Here the moderated discussion takes place - experts from different fields share their knowledge and moderate and summarize the discussion, grow the network and create impact. Within the moderated discussion, you gain knowledge from insiders and share your own. Groups can be open, private, or hidden. For private groups, you can request access. For hidden groups, you will need an invitation. You can also request your own group.</div>
          </div>

          <div class="search__content">
            <div class="dropdown">
              <a type="button" class="btn-filter" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ selectedType || 'All groups' }}
              </a>
              <div class="dropdown-menu">
                <a class="dropdown-item" href="#" @click.prevent="setType('')">All groups</a>
                <a class="dropdown-item" href="#" @click.prevent="setType('1')">Open</a>
                <a class="dropdown-item" href="#" @click.prevent="setType('2')">Private</a>
              </div>
            </div>

            <div class="search__form">
              <input v-model="searchQuery" type="text" @keyup.enter="onSearch">
              <button class="search__form-btn" @click="onSearch"><span class="search__form-icon"></span></button>
            </div>

            <div class="search__category">
              <div class="dropdown">
                <a type="button" class="btn-filter" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ selectedCategoryName || 'Category' }}
                </a>
                <div class="dropdown-menu">
                  <a class="dropdown-item" href="#" @click.prevent="setCategory(null)">All</a>
                  <a v-for="cat in categories" :key="cat.id" class="dropdown-item" href="#" @click.prevent="setCategory(cat)">{{ cat.name }}</a>
                </div>
              </div>

              <div class="dropdown">
                <a type="button" class="btn-filter" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ selectedStatusName || 'Status' }}
                </a>
                <div class="dropdown-menu">
                  <a class="dropdown-item" href="#" @click.prevent="setStatus('')">All</a>
                  <a class="dropdown-item" href="#" @click.prevent="setStatus('open')">Open</a>
                  <a class="dropdown-item" href="#" @click.prevent="setStatus('private')">Private</a>
                  <a class="dropdown-item" href="#" @click.prevent="setStatus('hidden')">Hidden</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="user-cabinet__area-top">
        <button class="btn btn-primary" @click="showModal = true">ADD NEW GROUP</button>
      </div>

      <div v-if="groups.length" class="user-group__list user-group__grid">
        <ItemGroup v-for="group in groups" :key="group.id" :group="group" />
      </div>

      <Pagination v-if="pagination.pageCount > 1" :pagination="pagination" @changepage="getGroups" />
    </div>

    <!-- Модал с формой заявки -->
    <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Request a new group</h5>
            <button type="button" class="close" @click="showModal = false"><span>&times;</span></button>
          </div>
          <div class="modal-body">
            <Alert :variant="variant" v-if="text">{{ text }}</Alert>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form class="form-block" @submit.prevent="handleSubmit(onGroupRequest)">
                <div class="form-block__body">
                  <ValidationProvider tag="div" rules="required" name="Group name" class="form-row" v-slot="{ errors }">
                    <input v-model="group.name" class="form-control" type="text" placeholder="Group Name">
                    <span v-if="errors.length" class="require_field">{{ errors[0] }}</span>
                  </ValidationProvider>

                  <div class="form-row">
                    <select class="form-control" v-model="group.category_id">
                      <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.name }}</option>
                    </select>
                  </div>

                  <div class="form-row">
                    <select class="form-control" v-model="group.style">
                      <option v-for="style in styles" :key="style.id" :value="style.id">{{ style.name }}</option>
                    </select>
                  </div>

                  <div class="form-row">
                    <select class="form-control" v-model="group.type">
                      <option v-for="option in typeOptions" :key="option.value" :value="option.value">{{ option.text }}</option>
                    </select>
                  </div>

                  <div class="form-row">
                    <select class="form-control" v-model="group.channels">
                      <option v-for="channel in channels" :key="channel.id" :value="channel.id">{{ channel.name }}</option>
                    </select>
                  </div>

                  <template v-if="group.type === '2'">
                    <ValidationProvider tag="div" rules="required" name="Your Name" class="form-row" v-slot="{ errors }">
                      <input v-model="group.owner_name" class="form-control" type="text" placeholder="Your Name">
                      <span v-if="errors.length" class="require_field">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <ValidationProvider tag="div" rules="required" name="Your Address" class="form-row" v-slot="{ errors }">
                      <input v-model="group.owner_address" class="form-control" type="text" placeholder="Your Address">
                      <span v-if="errors.length" class="require_field">{{ errors[0] }}</span>
                    </ValidationProvider>
                    <div class="form-row">
                      <input v-model.number="group.cost" step="0.01" class="form-control" type="number" placeholder="Membership cost per month">
                    </div>
                  </template>

                  <ValidationProvider tag="div" rules="required|max:400" name="Description" class="form-row" v-slot="{ errors }">
                    <textarea v-model="group.description" class="form-control" cols="30" rows="6" maxlength="401" placeholder="Group description"></textarea>
                    <span v-if="errors.length" class="require_field">{{ errors[0] }}</span>
                  </ValidationProvider>

                  <div class="form-row">
                    <label class="custom_checkbox_label">
                      <input class="form-control custom_checkbox" type="checkbox" @change="isReadPrivacy = !isReadPrivacy">
                      I have read and agree with the&nbsp;
                      <router-link :to="{ name: 'PrivacyPage' }" style="color:#1d9dd9; margin-left: 3px;">Privacy Policy</router-link>
                    </label>
                  </div>

                  <div class="btns-group--right">
                    <button class="btn btn-primary" type="submit" :disabled="!isReadPrivacy">Submit</button>
                  </div>
                </div>
              </form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import GroupService from '@/services/GroupService';
import DictionaryService from '@/services/DictionaryService';
import ItemGroup from '@/views/profile/MyGroups/ItemGroupV2.vue';
import Pagination from '@/views/profile/MyGroups/Pagination.vue';
import Alert from '@/components/Alert.vue';
import pagination from '@/mixins/pagination';
import exception from '@/mixins/exception';
import content from '@/mixins/content';
import alert from '@/mixins/alert';

export default {
  name: 'ProfileGroupsRequest',
  mixins: [pagination, exception, content, alert],
  components: { Alert, ItemGroup, Pagination },
  data() {
    return {
      groups: [],
      groupsLoaded: false,
      showModal: false,
      searchQuery: '',
      selectedType: '',
      selectedCategoryName: '',
      selectedCategoryId: null,
      selectedStatusName: '',
      selectedStatus: '',
      categories: [],
      styles: [],
      channels: [],
      typeOptions: [
        { text: 'Open', value: '1' },
        { text: 'Private', value: '2' },
      ],
      group: {
        name: '',
        type: '1',
        cost: 0,
        description: '',
        category_id: undefined,
        style: undefined,
        channels: undefined,
        owner_name: '',
        owner_address: '',
      },
      isReadPrivacy: false,
    };
  },
  async created() {
    this.pagination = {
      pageCurrent: +this.$route.query.page || 1,
      pageCount: 1,
      perPage: 5,
      total: 0,
    };
    await Promise.all([this.getGroups(), this.getCategories(), this.getStyles(), this.getChannels()]);
  },
  watch: {
    '$route.query.page': function () {
      this.getGroups();
    },
    searchQuery() {
      this.onSearch();
    },
  },
  methods: {
    async getGroups() {
      try {
        const res = await GroupService.groups({
          page: this.pagination.pageCurrent,
          'per-page': this.pagination.perPage,
          text: this.searchQuery || undefined,
          type: this.selectedType || undefined,
          category_id: this.selectedCategoryId || undefined,
        });
        this.groups = res.data;
        this.setPagination(res.headers);
        this.groupsLoaded = true;
      } catch (e) {
        this.handleException(e);
      }
    },
    onSearch() {
      this.pagination.pageCurrent = 1;
      this.getGroups();
    },
    setType(value) {
      this.selectedType = value;
      this.selectedTypeName = value === '1' ? 'Open' : value === '2' ? 'Private' : '';
      this.onSearch();
    },
    setCategory(cat) {
      this.selectedCategoryId = cat ? cat.id : null;
      this.selectedCategoryName = cat ? cat.name : '';
      this.onSearch();
    },
    setStatus(value) {
      this.selectedStatus = value;
      this.selectedStatusName = value ? value.charAt(0).toUpperCase() + value.slice(1) : '';
      this.onSearch();
    },
    async onGroupRequest() {
      try {
        await GroupService.groupsRequest(this.group);
        this.showModal = false;
        this.$router.push({ name: 'profileGroups', params: { type: 'request' } });
      } catch (e) {
        this.showAndHideAlertSuccess(e.response.data[0].message, 'danger');
      }
    },
    async getCategories() {
      try {
        const res = await DictionaryService.categories();
        this.group.category_id = res.data[0].id;
        this.categories = res.data;
      } catch (e) {
        this.handleException(e);
      }
    },
    async getStyles() {
      try {
        const res = await DictionaryService.styles();
        this.group.style = res.data[0].id;
        this.styles = res.data;
      } catch (e) {
        this.handleException(e);
      }
    },
    async getChannels() {
      try {
        const res = await DictionaryService.getChannelsCategories();
        this.group.channels = res.data[0].id;
        this.channels = res.data;
      } catch (e) {
        this.handleException(e);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-dialog {
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 560px;
  max-height: 90vh;
  overflow-y: auto;
}

.require_field {
  padding-left: 10px;
  font-size: 14px;
  color: #FF0000;
  font-weight: 500;
}

.custom_checkbox_label {
  display: flex;
}

.custom_checkbox {
  display: inline-block;
  width: 20px;
  height: 20px;
  min-height: auto;
  margin-right: 5px;
}

button[type=submit]:disabled {
  background-color: #cccccc;
  color: #FFF;
}
</style>
